import { jsx as _jsx } from "react/jsx-runtime";
import { RetrievalQueries } from "@faire/retailer-visitor-shared/features/RetrievalQueries/RetrievalQueries";
import { useCategoryPageAllRetrievalQueries } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useCategoryPageAllRetrievalQueries";
import { useCategoryPageRequestId } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useCategoryPageRequestId";
import React from "react";
export var CategoryPageRetrievalQueries = function() {
    var allRetrievalQueries = useCategoryPageAllRetrievalQueries();
    var requestId = useCategoryPageRequestId();
    return /*#__PURE__*/ _jsx(RetrievalQueries, {
        allRetrievalQueries: allRetrievalQueries,
        requestId: requestId
    });
};
